// extracted by mini-css-extract-plugin
export default {"childWarning":"ChildWarning-module_childWarning__xlDtE"};